import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { QuizSelectResultField } from '@fmnts/api/next';
import { DeclarativeForm, FormDeclaration } from '@fmnts/declarative-forms';
import { FieldsetDeclaration } from '@fmnts/declarative-forms/core';
import { InlineTranslateable } from '@fmnts/i18n';
import {
  faCheck,
  faSquare,
  faSquareCheck,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons';
import { EMPTY, Observable, map, of } from 'rxjs';
import { SharedDeclarativeCampaignFormsModule } from '../../shared-declarative-next-forms.module';

interface Option {
  label: InlineTranslateable;
  checked: boolean;
  correct: boolean;
}
/**
 * Summary field for displaying checkbox groups
 */
@Component({
  selector: 'next-quiz-summary-field',
  styleUrls: ['./quiz-summary-field.component.scss'],
  templateUrl: './quiz-summary-field.component.html',
  standalone: true,
  imports: [SharedDeclarativeCampaignFormsModule],
})
export class QuizSummaryFieldComponent implements OnInit {
  @Input({ required: true }) declaration!: FormDeclaration;
  @Input({ required: true }) field!: QuizSelectResultField;
  @Input({ required: true }) fieldset!: FieldsetDeclaration;
  @Input({ required: true }) form!: DeclarativeForm;
  @Input({ required: true }) control!: AbstractControl;

  public allOptions$: Observable<Option[]>;

  /** Icons to show, whether option was checked or not */
  public readonly iconChecked = faSquareCheck;
  public readonly iconUnchecked = faSquare;

  /** Icons to show, whether option was answered correct */
  public readonly iconCorrect = faCheck;
  public readonly iconIncorrect = faXmark;

  ngOnInit(): void {
    this.allOptions$ = this.getAllOptions$();
  }

  get fieldIsCorrect() {
    return this.control?.valid;
  }

  private getAllOptions$(): Observable<Option[]> {
    if (!this.field) {
      return EMPTY;
    }

    const { items, validators, defaultValue } = this.field.widgetOptions;

    return of(items).pipe(
      map((itemsArr) =>
        itemsArr.map((i) => ({
          label: i.label,
          checked: defaultValue.includes(i.value),
          correct: this.includesExactly(
            defaultValue.includes(i.value),
            i.value,
            validators[0].args.values,
          ),
        })),
      ),
    );
  }

  private includesExactly(
    isChecked: boolean,
    answer: number,
    solution: number[],
  ) {
    return isChecked ? solution.includes(answer) : !solution.includes(answer);
  }
}
